import React from 'react';
import { Menu as HLMenu, Transition } from '@headlessui/react';
import useMenuContext from './useMenuContext';
import tw from 'twin.macro';
import { css } from '@emotion/react';
import PortalWrapper from '@teetsh/app/src/components/PortalWrapper';

interface Props {
  children: React.ReactNode;
  fill?: boolean;
  size?: 'xl' | 'lg' | 'md' | 'sm' | 'xs' | 'auto';
  className?: string;
  limitHeight?: boolean;
}

export const menuItemsStyle = [
  tw`origin-top-right bg-white divide-y rounded-lg focus:outline-none overflow-hidden z-50`,
  css`
    box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2),
      0 8px 24px rgba(16, 22, 26, 0.2);
  `,
];

const sizeToWidth = {
  xs: tw`w-32`,
  sm: tw`w-52`,
  md: tw`w-64`,
  lg: tw`w-72`,
  xl: tw`w-80`,
  auto: tw`w-auto`,
};

export function MenuItems(props: Props) {
  const { children, size = 'auto', limitHeight = false, className } = props;
  const { refs, portal, open, floatingStyles } = useMenuContext();
  return (
    <PortalWrapper portal={portal}>
      <div
        ref={refs.setFloating}
        style={{ ...floatingStyles, zIndex: 50 }}
        className={className}
      >
        <Transition
          show={!!open}
          enter="menuEnter"
          enterFrom="menuEnterFrom"
          enterTo="menuEnterTo"
          leave="menuLeave"
          leaveFrom="menuLeaveFrom"
          leaveTo="menuLeaveTo"
        >
          <HLMenu.Items
            static
            css={[
              ...menuItemsStyle,
              sizeToWidth[size],
              limitHeight && tw`overflow-y-auto max-h-96`,
            ]}
          >
            {children}
          </HLMenu.Items>
        </Transition>
      </div>
    </PortalWrapper>
  );
}
